/*
  This function is used to check if the input string is a url or not
*/
export function isValidHttpUrl(content: string): boolean {
  let url;
  try {
    url = new URL(content);
  } catch (_) {
    return false;
  }
  return url.protocol === 'http:' || url.protocol === 'https:';
}
// link: https://regexr.com/39nr7
const regex: RegExp =
  // eslint-disable-next-line no-useless-escape
  /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi;

/**
 * This function use to get all url in a string
 */
export function getUrlInContent(content: string): RegExpMatchArray | null {
  return content.match(regex);
}

/**
 * This function use to check if a string have url
 */
export function checkContentHaveUrl(content: string): boolean {
  const res = content.match(regex);
  return !!res && res.length > 0;
}

export const getParams = (key: string): string => {
  const params = new window.Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop as string),
  });
  return params[key as keyof typeof params] as unknown as string;
};
